/**
* featured image two JS
* -----------------------------------------------------------------------------
*
* All the JS for the featured image two component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'featured-image-two',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.featured-image-two' ).each( function() {
        const leftTop = $( this ).find( '.side-colors .image-top-bg.left' )[0];
        const leftBottom = $( this ).find( '.side-colors .image-bottom-bg.left' )[0];
        const rightTop = $( this ).find( '.side-colors .image-top-bg.right' )[0];
        const rightBottom = $( this ).find( '.side-colors .image-bottom-bg.right' )[0];
        const height = $( this ).outerHeight();

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 35%',
            end: '150% 0%',
            scrub: 0,
            // markers: true,
          },
        } );
        tl.to( leftTop, {scaleX: 0, ease: 'linear'}, 0 );
        tl.to( leftBottom, {scaleX: 0, ease: 'linear'}, 0 );
        tl.to( rightTop, {scaleX: 0, ease: 'linear'}, 0 );
        tl.to( rightBottom, {scaleX: 0, ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-image-two', COMPONENT );
} )( app );
